import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CommunityService } from '../services/community/community.service';

export const CommunityFullviewResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const communityService = inject(CommunityService);
  const router = inject(Router);
  let communityId = route.paramMap.get('communityId');
  if(!communityId){
    communityId = route.queryParamMap.get('communityId');
  }

  if(!communityId) {
    router.navigate(['/']);
    return false;
  }

  const campaignId = route.queryParamMap.get('campaignId');
  return communityService.CommunitySharable(communityId, campaignId).pipe(
    map((response: { campaignId?: number, communityId?: number }) => {
      if(response.campaignId){
        router.navigate([`/community/${response.communityId}/campaign/${response.campaignId}/overview`]); 
      } else {
        const hash = location.hash;
        let postfix = '';
        switch(hash){
          case '#campaigns':
            postfix = 'campaigns';
            break;
          case '#items':
          case '#map':
            postfix = 'stories';
            break;
          case '#gallery':
            postfix = 'stories/gallery';
            break;
        }
        router.navigate([`/community/${response.communityId}/${postfix}`]); 
      }
      return false;
    }),
    catchError((res) => {
      router.navigate([`/`]);
      return of(false);
    })
  );
};